import * as types from '../types'

const init = {
  // data: {
  //   title: '22222',
  //   btnText: '我知道了',
  //   reward: {
  //     rewardAmountDesc: '10元',
  //     rewardName: '白条券',
  //     rewardDesc: '限京东白条全品类',
  //     rewardLabel: '10*3',
  //   }
  // },
  data: null
}

const alert = (state = init, action) => {
  switch (action.type) {
    case types.ALERT_SHOW: {
      console.log(action)
      return {
        ...state,
        data: action.data,
      }
    }
    case types.ALERT_HIDE: {
        
      return {
        ...state,
        data: null,
      }
    }

    default:
      return state
  }
}

export default alert
